import { H4 } from "../typography/H4";

interface Props {}

export const PartnerMyProfileHeader: React.FC<Props> = ({}) => {
  return (
    <div className="flex flex-col">
      {/* <Breadcrumb className="pb-0">
        <Breadcrumb.Item>관리자 정보</Breadcrumb.Item>
        <Breadcrumb.Item>관리자 정보</Breadcrumb.Item>
        <Breadcrumb.Item>내 계정 상세 정보</Breadcrumb.Item>
      </Breadcrumb> */}
      <div className="flex items-center justify-between h-[50px] mb-[12px]">
        <div className="mt-[15px] mb-[7px]">
          <H4>내 정보</H4>
        </div>
        <div />
        {/* <Button
          disabled={disabled}
          color={disabled ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
          onClick={onClickButton}
        >
          정보 저장
        </Button> */}
      </div>
    </div>
  );
};
